import axios from "axios";
import { c2cUrl } from "../constants/url-constants";

const api = axios.create({
    baseURL: c2cUrl()
});

const getListingDataViaAppId = ({ appId, secureToken }) => {
    return api.get(`/api/seller/v2/subscription/appointmentId/${appId}`, {
        headers: {
            "Authorization": `Bearer ${secureToken}`
        }
    });
};

const initiateListing = (data, secureToken) => {
    return api.post(`/api/seller/v1/subscription/create`, data, {
        headers: {
            "Authorization": `Bearer ${secureToken}`
        }
    });
};

export default {
    getListingDataViaAppId,
    initiateListing
};

